import { t } from 'i18next';
import ClockLoader from "react-spinners/ClockLoader";
import ImageGallery from 'react-image-gallery';

export function generateSimpleList(list) {
  return list.map((item) => <li>{t(item)}</li>);
}

export function importAll(images) {
  let Allimages = {};
   images.keys().forEach((item, index) => { Allimages[item.replace('./', '')] = images(item); });
  return Allimages
 }

 function prepareImageForSlider(ObjectOFimages) {
  let images = [];

  for (let image in ObjectOFimages) {
      images.push(
          {
              original: ObjectOFimages[image],
              thumbnail: ObjectOFimages[image],
          }
      )
  }

  return images;
 }

export function generateImageTabs(images, loading, setLoading, thumbnailPosition="left", fixedHeight = null) {
    const isNumericHeight = Number.isFinite(fixedHeight) && fixedHeight > 0;
    const isStringHeight = typeof fixedHeight === 'string' && fixedHeight.trim().length > 0;
    const hasFixedHeight = isNumericHeight || isStringHeight;
    const resolvedHeight = isNumericHeight ? `${fixedHeight}px` : fixedHeight;
    const wrapperStyle = hasFixedHeight
        ? { minHeight: resolvedHeight, position: 'relative' }
        : undefined;

    const galleryStyle = hasFixedHeight
        ? { display: loading ? 'none' : 'block', height: resolvedHeight, overflow: 'hidden' }
        : { display: loading ? 'none' : 'block' };

    const loaderContainerStyle = hasFixedHeight
        ? {
                display: loading ? 'flex' : 'none',
                webkitBoxPack: 'center',
                placeContent: 'center',
                placeItems: 'center',
                webkitBoxAlign: 'center',
                minHeight: resolvedHeight,
            }
        : {
            display: loading ? 'flex' : 'none',
            webkitBoxPack: 'center',
            placeContent: 'center',
            placeItems: 'center',
            webkitBoxAlign: 'center',
        };

  return (
            <div style={wrapperStyle}>
                    <div style={galleryStyle}>
                            <ImageGallery items={prepareImageForSlider(images)} autoPlay={true} onImageLoad={() => setLoading(false)}
                  thumbnailPosition={thumbnailPosition} lazyLoad={true} slideInterval={8000} />
          </div>
                    <div style={loaderContainerStyle}>
              <ClockLoader
                  color={"#feda00"}
                  loading={loading}
                  size={100}
                  aria-label="Loading Spinner"
                  data-testid="loader"
              />
          </div>

      </div>
  )
}